export default __webpack_public_path__ + "static/media/user.62d6ebda.svg";